import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { ConfigSettings } from "../../config/Config";
import Iframe from "../../components/Iframe";
import { QueryString } from "../../common/helper";
import { useHistory } from "react-router";
import CalculatorIcon from "../../layout/left_menu_icons/calculator.svg";
import RiseProjectEstimation from "./RiseProjectEstimation";
import CorpProjectEstimation from "./CorpProjectEstimation";

const ProjectEstimationPage = (props) => {
  const settings = ConfigSettings();
  const { t } = useTranslation();
  const [urlparameterKey, setUrlParameterKey] = useState();
  const [returnUrl, setReturnUrl] = useState();
  const [projectEstimationOptions, setProjectEstimationOptions] = useState([]);
  const [url, setUrl] = useState("");
  const [fullName, setFullName] = useState();

  let history = useHistory();

  const optionUrls = {
    PT: `${settings.outSystemBaseUrl}/P_Cast/Simulation?`,
    ES: `${settings.outSystemBaseUrl}/P_Cast/SimulationES?`
  };

  const interviewId = props.match.params.interviewId;
  const hash = QueryString.getUrlParameter("hash");

  function goToInterview(_url) {
    history.push(_url);
  }

  useEffect(() => {
    let parm = QueryString.getUrlParameter("returnUrl");
    if (parm) setReturnUrl(`/${parm}`);
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={CalculatorIcon} alt="ni-icon" />

            <h1 style={{ marginTop: "10px" }}>
              {t("Project Estimation")} {fullName && `- ${fullName}`}
            </h1>
          </div>
        </div>

        <div className="text-end col-auto">
          {returnUrl && (
            <a
              href="#!"
              className="btn app-button btn-second btn-lg"
              onClick={() => goToInterview(returnUrl)}
            >
              {t("Back")}
            </a>
          )}
        </div>
      </div>
      <RiseProjectEstimation
        interviewId={interviewId}
        hash={hash}
        setFullName={setFullName}
        setUrl={setUrl}
        url={url}
        setUrlParameterKey={setUrlParameterKey}
      />
    </>
  );
};

export default ProjectEstimationPage;
